import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ReportingFrequencyForm from '../Forms/ReportingFrequencyForm';

const AddEditReportingFrequencyModal = ({
	dataReportingFrequency,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Frecuencia de Reportabilidad
			</ModalHeader>

			<ReportingFrequencyForm
				dataReportingFrequency={dataReportingFrequency}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditReportingFrequencyModal;
